/**
 * 金钱转换 - 分转元
 * @param {Number} fen 分
 * @param {Boolean} nodot 保留小数位末尾的0，如果为true返回的将会是String<Number>
 */
export function fen2yuan(fen, nodot = true) {
  let yuan = (fen / 100).toFixed(2)
  if (nodot) {
    return yuan
  } else {
    return yuan - 0
  }
}

/**
 * 金钱转换 - 元转分
 * @param {Number} yuan 元
 */
export function yuan2fen(yuan) {
  return (yuan * 100).toFixed(0) - 0
}

/**
 * 字符串字节长度
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/gi) != null) {
      len += 1
    } else {
      len += 0.5
    }
  }
  return Math.floor(len)
}

/**
 * 清空数组中无内容的元素
 * @param {Array} actual 数组
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * 对象格式化为URL参数
 * @param {Object} json 参数对象
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * URL参数格式化为对象
 * @param {String} url
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"') +
    '"}'
  )
}

/**
 * 数组去重
 * @param {Array} arr 数组
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * 判断字符串是否是外链
 * @param {String} path 路径连接
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * 去抖函数
 * @param {Function} func 延迟执行函数
 * @param {Number} wait 延迟时间
 * @param {*} immediate
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * 判断移动设备
 * @returns {Boolean}
 */
export function isMobile() {
  if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    return true
  } else {
    return false
  }
}

/**
 * 延迟
 */
export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}
